const getPrefetchers = (components, params, context = {}) =>
  components.reduce((result, component) => {
    const prefetcher =
      (component && component.default && component.default.prefetch) ||
      component.prefetch;

    if (prefetcher) return [...result, prefetcher(params, context)];

    return [...result];
  }, []);

export default getPrefetchers;



//////////////////
// WEBPACK FOOTER
// ./server/utils/getPrefetchers.js
// module id = 825
// module chunks = 34